export enum MiniSiteActionTypes {
  UPDATE_API_KEY_FAILED = "UPDATE_API_KEY_FAILED",
  SEND_REPORT_STATS = "SEND_REPORT_STATS",
  SEND_REPORT_AGGREGATOR = "SEND_REPORT_AGGREGATOR",
  SEND_REPORT_CALLCENTER = "SEND_REPORT_CALLCENTER",
  SEND_REPORT_FLYNOTES = "SEND_REPORT_FLYNOTES",
  SEND_REPORT_SELFCHECKIN = "SEND_REPORT_SELFCHECKIN",
}
